import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { BreadCum } from "../../../layout/admin";

export class LayoutWrapper extends Component {
  render() {
    let { props } = this;
    let { title, back = "", className = "", backlink, headerRight, customBreadcrumb } = props;
    return (
      <div className={"content container-fluid relative" + className}>
        <Helmet>
          <title>{title} - CognoSpace</title>
          <meta name="description" content="School Infra Maintenance Tracker" />
        </Helmet>
        <div className="page-header">
          <div className="row align-items-center">
            <div className="col">
              {customBreadcrumb ? (
                <div>
                  <h3 className="page-title">{title}</h3>
                  {customBreadcrumb}
                </div>
              ) : (
                <BreadCum title={title} back={back} backlink={backlink} />
              )}
            </div>
            {headerRight && (
              <div className="col-auto float-end ms-auto">
                {headerRight}
              </div>
            )}
          </div>
        </div>
        {props.children}
      </div>
    );
  }
}

export default connect(LayoutWrapper);
